export const SENDER_USER = 'user';
export const SENDER_ASSISTANT = 'assistant';

export const parseThreadToChat = (thread) =>
  thread.reverse().flatMap((messagePair) => [
    {
      sender: SENDER_USER,
      text: messagePair.UserMessage || '',
      timestamp: new Date(messagePair.CreatedAt),
    },
    {
      sender: SENDER_ASSISTANT,
      text: messagePair.AssistantResponse || '',
      timestamp: new Date(messagePair.CreatedAt),
    },
  ]);
